import { useApi } from "@/ApiContext";
import BotaoPrincipal from "@/components/BotaoPrincipal";
import BotaoSecundario from "@/components/BotaoSecundario";
import BotaoText from "@/components/BotaoText";
import { Password } from "@/components/Password";
import { Socials } from "@/components/socials";
import TituloTelaAcao from "@/components/TituloTelaAcao";
import { registerMetadata } from "@/services/metadataEvent";
import { setInfoToaster } from "@/store/reducers/geral";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import MoodOutlinedIcon from "@mui/icons-material/MoodOutlined";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

export default function DialogLoginCliente({
  infoDialogLogin,
  setInfoDialogLogin,
}) {
  const dispatch = useDispatch();
  const [avisoLogin, setAvisoLogin] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const navigation = useNavigate();
  const { postClient } = useApi();

  const Schema = Yup.object().shape({
    cpfCnpj: Yup.string().required("Informe seu CPF"),
    password: Yup.string().required("Informe sua senha"),
  });

  const cancelar = () => {
    dispatch(setInfoDialogLogin({ open: false }));
  };

  const formik = useFormik({
    initialValues: {
      cpfCnpj: "",
      password: "",
      loginType: "CLIENTE",
    },
    validationSchema: Schema,
    onSubmit: async (values) => {
      const metaData = {};
      metaData.isMobile = isMobile;
      metaData.userAction = `LOGIN_SIMULATOR`;
      metaData.url = window.location.href;
      registerMetadata(metaData);
      setAvisoLogin({});
      values.idRequestBind = infoDialogLogin.idRequestBind;
      values.tokenRequestBind = infoDialogLogin.tokenRequestBind;
      const result = await postClient("public/login", values);

      if (result.error) {
        setAvisoLogin({ open: true, descricao: result.error });
        return;
      }

      sessionStorage.setItem(
        "dadosUsuarioLogado",
        JSON.stringify(result.data.user)
      );
      dispatch(
        setInfoToaster({
          open: true,
          message: "Login efetuado com sucesso",
          type: "success",
        })
      );

      navigation("/app/area-cliente/inicio");
    },
  });

  useEffect(() => {
    setCarregar(true);
  }, []);

  useEffect(() => {
    if (!carregar) {
      return;
    }
    setCarregar(false);
    if (!!infoDialogLogin.cpfCnpj) {
      formik.setFieldValue("cpfCnpj", infoDialogLogin.cpfCnpj);
    }
  }, [carregar, formik, infoDialogLogin.cpfCnpj]);

  const cadastrar = () => {
    sessionStorage.setItem("idRequestBind", infoDialogLogin.idRequestBind);
    sessionStorage.setItem(
      "tokenRequestBind",
      infoDialogLogin.tokenRequestBind
    );
    if (infoDialogLogin.idRequestBind) {
      navigation(
        `/app/cadastro/${infoDialogLogin.idRequestBind}/${infoDialogLogin.tokenRequestBind}`
      );
    } else {
      navigation("/app/cadastro");
    }
  };

  const esqueciMinhaSenha = () => {
    sessionStorage.setItem("idRequestBind", infoDialogLogin.idRequestBind);
    sessionStorage.setItem(
      "tokenRequestBind",
      infoDialogLogin.tokenRequestBind
    );
    navigation("/app/esqueci-minha-senha");
  };

  return (
    <Dialog
      open={infoDialogLogin.open}
      style={{ maxWidth: "600px", margin: "auto" }}
      onClose={cancelar}
      aria-labelledby="alert-dialog-title"
      className="dialog-transacao"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <IconButton
          aria-label="close"
          onClick={cancelar}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          sx={{ p: { xs: 1, display: "flex", justifyContent: "center" } }}>
          <Grid size={10}>
            <TituloTelaAcao>
              Acesse ou crie sua conta para continuar:
            </TituloTelaAcao>
          </Grid>

          {avisoLogin.open && (
            <Grid size={12}>
              <Alert
                severity={avisoLogin.type || "error"}
                onClose={() => {
                  setAvisoLogin({ open: false });
                }}>
                {avisoLogin.descricao}
              </Alert>
            </Grid>
          )}
        </Grid>

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid size={12}>
              <TextField
                fullWidth
                name="cpfCnpj"
                label="CPF/CNPJ *"
                autoComplete="username"
                variant="outlined"
                disabled={!!infoDialogLogin.cpfCnpj}
                sx={{ mb: 2 }}
                value={formik.values.cpfCnpj}
                onChange={formik.handleChange}
                error={formik.touched.cpfCnpj && Boolean(formik.errors.cpfCnpj)}
                helperText={formik.touched.cpfCnpj && formik.errors.cpfCnpj}
                slotProps={{
                  input: {
                    startAdornment: (
                      <MoodOutlinedIcon
                        sx={{ mr: 2, width: 24, height: 24 }}
                        color="primary"
                      />
                    ),
                  },
                  inputProps: {
                    maxLength: 18,
                  },
                }}
              />
            </Grid>
            <Grid size={12}>
              <Password
                textLabel={"Senha*"}
                value={formik.values.password}
                onChange={(event) => {
                  formik.setFieldValue("password", event.target.value);
                }}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
              />
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Box>
              <BotaoPrincipal
                endIcon={<ArrowForwardIcon />}
                type="submit"
                sx={{ mt: 3, ml: 1, color: "#D8FF57" }}>
                CONTINUAR
              </BotaoPrincipal>
            </Box>
          </Grid>
          <Grid xs={12} style={{ marginTop: "1rem" }}>
            <Box>
              <BotaoText
                fullWidth
                onClick={() => {
                  esqueciMinhaSenha();
                }}>
                ESQUECI MINHA SENHA
              </BotaoText>
            </Box>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              my: 1,
            }}
            size={12}>
            <Socials
              {...{
                idRequestBind: infoDialogLogin.idRequestBind,
                tokenRequestBind: infoDialogLogin.tokenRequestBind,
              }}
            />
          </Grid>
        </form>
        <Typography align="center" sx={{ mt: 2, mb: 1 }}>
          Não possui uma conta?
        </Typography>

        <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Box>
            <BotaoSecundario
              onClick={() => {
                cadastrar();
              }}>
              CRIAR CONTA
            </BotaoSecundario>
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
